export default __webpack_public_path__ + "static/VehicleSearchAgent-f0f1139b1a3ebbb758b5dcdf89315326.jpg";